export const XLSX_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const XLS_MIME_TYPE = 'application/vnd.ms-excel';

/**
 * The content type to presign a workbook upload with.
 *
 * `File.type` is not dependable for spreadsheets — a machine with nothing
 * registered for `.xls`/`.xlsx` reports an empty string, and the presign check
 * would refuse a workbook that reads perfectly well. Fall back to the
 * extension.
 */
export function workbookContentType(file: File): string {
  if (file.type === XLSX_MIME_TYPE || file.type === XLS_MIME_TYPE) {
    return file.type;
  }
  return file.name.toLowerCase().endsWith('.xls')
    ? XLS_MIME_TYPE
    : XLSX_MIME_TYPE;
}
